import { Badge, BadgeGroup } from '@synqo/frontend-component-library';
import { getUserGroupVariant } from './getUserGroupVariant';
import type { ApiGroup } from '@Model';

interface IGroupLinkProps {
    groupId: string;
    groups: ApiGroup[];
}

interface IGroupLinksProps {
    groupIds: string[];
    groups: ApiGroup[];
}

export function GroupsLinks({ groupIds, groups }: IGroupLinksProps) {
    return (
        <BadgeGroup>
            {groupIds
                .sort((a, b) => a.localeCompare(b))
                .map((groupId) => (
                    <GroupLink key={groupId} groupId={groupId} groups={groups} />
                ))}
        </BadgeGroup>
    );
}

function GroupLink({ groupId, groups }: IGroupLinkProps) {
    const group = groups.find((group) => group.id === groupId);
    return group && <Badge variant={getUserGroupVariant(groupId)}>{group?.label}</Badge>;
}
